export const Logo = (props: any) => <img src="/logo/logo_single.svg" alt="logo" />;
export const logoHeight = '14px';
